<template>
   <div class="animated fadeIn">
    <div class="row">
      <div class="col-sm-12">
        <div class="card">
          <div class="card-header">
            <div slot="header">
              <div class="row">
                <div class="col-sm-10">
                  <i style="color: #20a8d8;"></i> Payment Details 
                </div>
              </div>
            </div>
          </div> 
          <div class="card-body">
            <vue-good-table
              mode="remote"
              ref="my-table"
              @on-page-change="onPageChange"
              @on-sort-change="onSortChange"
              @on-column-filter="onColumnFilter"
              @on-per-page-change="onPerPageChange"
              :totalRows="totalRecords"
              :columns="columns4"
              :rows="rows4"
              :pagination-options="{
                enabled: true,
                perPage: 5,
              }"
              styleClass="vgt-table striped bordered table-sm condensed"
            >
              <template slot="table-row" slot-scope="props">
                <span v-if="props.column.field == 'pay_date'">
                  {{ newDate(props.row.pay_date) }}
                </span>
                <span v-else>
                  {{ props.formattedRow[props.column.field] }}
                </span>
              </template>
            </vue-good-table>
          </div>
          
        </div>
      </div>
    </div>
    <Spinner v-if="loading"></Spinner>
  </div>
</template>

<script>    
import Spinner from "../../spinner.vue";
import { VueEditor } from "vue2-editor";
import DatePicker from "vue2-datepicker";
import company_mgmtVue from '../admin_pages/company_mgmt.vue';


export default 
{
    name: 'CardDetail',
    components: 
    {
        "date-picker": DatePicker,
        Spinner,
    }, 
    data() 
    {
        return {
        rows: [],
        rows4: [],
        rows5: [],
        todate: "",
        fromdate: "",
        temprow: null,
        warningModal: false,
        warningModal1: false,
        largeModal: false,
        loading: false,
        totalRecords: 0,
        serverParams: {
            columnFilters: {},
            sort: {
            field: "purchase_id",
            type: "asc",
            },
            page: 1,
            perPage: 5,
        },
        serverParams1: {
            columnFilters: {},
            sort: {},
            page: 1,
            perPage: 10,
        },
        serverParams2: {
            columnFilters: {},
            sort: {},
            page: 1,
            perPage: 10,
        },
        columns4: [
            {
              label: "Customer Name",
              field: "cust_cmp_name",
              width: "10% !important",
              thClass: "text-left",
            },
            {
            label: "Ledger No.",
            field: "ledger_no",
            width: "10% !important",
            thClass: "text-left",
            },
            {
            label: "Order ID",
            field: "order_id",
            width: "10% !important",
            thClass: "text-left",
            },
            {
            label: "Received Date",
            field: "pay_date",
           
            
            tdClass: "text-left",
            thClass: "text-left",
            width: "15% !important",
            },
            {
            label: "Amount",
            field: "pay_monthly",
            width: "15% !important",
            thClass: "text-left",
            },
            {
            label: "Payable Month",
            field: "pay_month",
            width: "15% !important",
            thClass: "text-left",
            },
            {
            label: "Company Name",
            field: "company_name",
            width: "15% !important",
            thClass: "text-left",
            }
          ],
        };
    },
    async created()
    {
      await this.getPayStatement()
    },
    methods: 
    {   
      newDate(date1) 
      {
        var dt1 = new Date(date1);
        var year = dt1.getFullYear();
        var month = dt1.getMonth() + 1;
        var day = dt1.getDate();
        if (day < 10) 
        { day = "0" + day; }
        if (month < 10) 
        { month = "0" + month; }
        var dt2 = day + "-" + month + "-" + year;
        // var dt2 = year+'-'+month+'-'+day
        return dt2;
      },
      getPayStatement()
      {   
        var _this = this;
        var customer_phn = localStorage.getItem('authUserid')
        console.log("this is payment phone no: " +customer_phn)
        var data = "&filter[where][cust_cmp_phone]=" +customer_phn
        console.log("/api/customerpaystatements/getPaymentDetails?params="+data)
        this.$http.get("/api/customerpaystatements/getPaymentDetails?params="+data)
        .then(function (response) 
        {
            console.log(response.data)
            _this.rows4 = response.data;
        });
      }
    } 
}
</script>


// WEBPACK FOOTER //
// src/views/goldcustomers/customerPaymentStatement.vue